import {IonCol, IonContent, IonGrid, IonItem, IonLabel, IonLoading, IonPage, IonRow, IonToast,} from "@ionic/react";
import React, {useState} from "react";
import {useLocation, withRouter} from "react-router-dom";

import {AuthContext} from "../../providers/authContext";
import "./Page.css";
import Header from "../../components/Header";

const BorcTahsilatBasarisiz: React.FC = () => {
  const { setTitle } = React.useContext(AuthContext);
  const { search } = useLocation<any>();

  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const [tahsilatHata, setTahsilatHata] = useState<string>();

  React.useEffect(() => {
    setTitle("Tahsilat Sonucu");
    const params = new URLSearchParams(search);
    setTahsilatHata(params.get("errMsg")!);
    window.history.pushState({}, "", "/");
  }, []);

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={3000}
          position="middle"
        />
        {tahsilatHata && (
          <IonItem>
            <IonGrid>
              <IonRow className="ion-text-center">
                <IonCol size="1">
                  <img src="assets/denied.png" alt="denied" />
                </IonCol>
                <IonCol>
                  <IonLabel>{tahsilatHata}</IonLabel>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="1" />
                <IonCol className="tips">
                  <strong>💡 İşlem başarısız olma sebepleri:</strong>
                  <ul>
                    <li>Kart bilgileriniz hatalı olabilir</li>
                    <li>Kartınızda yeterli bakiye olmayabilir</li>
                    <li>Kartınızın internet alışverişe kapalı olabilir</li>
                    <li>3D Secure şifrenizi yanlış girmiş olabilirsiniz</li>
                    <li>Kartınızın günlük/aylık limit aşımı olabilir</li>
                  </ul>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonItem>
        )}
      </IonContent>
    </IonPage>
  );
};

export default withRouter(BorcTahsilatBasarisiz);
